import React, { FC } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Button } from '@mui/material'
import { ScanQrCode } from 'lucide-react'
import { history } from 'middleware'
import { isUserReseller } from 'auth/selectors'
import { pathUtils } from 'utils/pathnameFormatter'
import AddOrder from './utilitiesHeader/addOrder'
import './pageActions.scss'
import { useTranslation } from 'translations'

const OrdersPageActions: FC = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const isReseller = useSelector(isUserReseller)

    return (
        <div className="orders-page-actions">
            {!isReseller && (
                <Button
                    variant="outlined"
                    size="medium"
                    color="secondary"
                    onClick={() => {
                        history.push(pathUtils.addPath(location.pathname, 'redeemMode', location.search))
                    }}
                    data-testid="orders-redeemer-button"
                    startIcon={<ScanQrCode size={16} />}
                >
                    {t('orders.orders.ordersTable.redeemerButton')}
                </Button>
            )}
            <AddOrder />
        </div>
    )
}

export default OrdersPageActions
